export default {
    joinFooterItems: {
        root: {
            title: 'Ready to get started?',
            text:
                'Explore Checkbook, or create an account instantly and start sending payments. You can also contact us to design a custom package for your business.',
            but1: {
                text: 'Create Account',
                link: 'https://app.checkbook.io/register',
            },
            but2: {
                text: 'Contact Sales',
                link: '/resource/contact-sales/',
            },
            col1Header: 'Always know what you pay',
            col1Text: 'Integrated per-transaction pricing with no hidden fees.',
            col1Btn: {
                text: 'Pricing details',
                link: '/pricing/',
            },
            col2Header: 'Start your integration',
            col2Text: 'Get up and running with Checkbook in as little as 10 minutes.',
            col2Btn: {
                text: 'API reference',
                link: 'https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
            },
        },
        compliance: {
            title: 'Ready to get started?',
            text:
                'Explore Checkbook, or create an account instantly and start sending payments. You can also contact us to design a custom package for your business.',
            but1: {
                text: 'Create Account',
                link: 'https://app.checkbook.io/register',
            },
            but2: {
                text: 'Contact Sales',
                link: 'https://calendly.com/checkbook',
            },
            col1Header: 'Always know what you pay',
            col1Text: 'Integrated per-transaction pricing with no hidden fees.',
            col1Btn: {
                text: 'Pricing details',
                link: '/pricing/',
            },
            col2Header: 'Start your integration',
            col2Text: 'Get up and running with Checkbook in as little as 10 minutes.',
            col2Btn: {
                text: 'API reference',
                link: 'https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
            },
        },
        quickbooks_disconnect: {
            title: 'Changed your mind?',
            text:
                'Explore Checkbook, or create an account instantly and start sending payments. You can also contact us to design a custom package for your business.',
            but1: {
                text: 'Reconnect to QuickBooks',
                link: '/quickbooks',
            },
            but2: {
                Text: 'Contact Sales',
                link: '/resource/contact-sales/',
            },
            col1Header: 'Always know what you pay',
            col1Text: 'Integrated per-transaction pricing with no hidden fees.',
            col1Btn: {
                text: 'Pricing details',
                link: '/pricing/',
            },
            col2Header: 'Start your integration',
            col2Text: 'Get up and running with Checkbook in as little as 10 minutes.',
            col2Btn: {
                text: 'API reference',
                link: 'https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
            },
        },
    },
    enca_joinFooterItems: {
        root: {
            title: 'Ready to get started?',
            text:
                'Explore Checkbook, or create an account instantly and start sending payments. You can also contact us to design a custom package for your business.',
            but1: {
                text: 'Create Account',
                link: 'https://app.checkbook.io/register',
            },
            but2: {
                text: 'Contact Sales',
                link: '/en-ca/resource/contact-sales/',
            },
            col1Header: 'Always know what you pay',
            col1Text: 'Integrated per-transaction pricing with no hidden fees.',
            col1Btn: {
                text: 'Pricing details',
                link: '/en-ca/pricing/',
            },
            col2Header: 'Start your integration',
            col2Text: 'Get up and running with Checkbook in as little as 10 minutes.',
            col2Btn: {
                text: 'API reference',
                link: 'https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
            },
        },
        compliance: {
            title: 'Ready to get started?',
            text:
                'Explore Checkbook, or create an account instantly and start sending payments. You can also contact us to design a custom package for your business.',
            but1: {
                text: 'Create Account',
                link: 'https://app.checkbook.io/register',
            },
            but2: {
                text: 'Contact Sales',
                link: 'https://calendly.com/checkbook',
            },
            col1Header: 'Always know what you pay',
            col1Text: 'Integrated per-transaction pricing with no hidden fees.',
            col1Btn: {
                text: 'Pricing details',
                link: '/en-ca/pricing/',
            },
            col2Header: 'Start your integration',
            col2Text: 'Get up and running with Checkbook in as little as 10 minutes.',
            col2Btn: {
                text: 'API reference',
                link: 'https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
            },
        },
        quickbooks_disconnect: {
            title: 'Changed your mind?',
            text:
                'Explore Checkbook, or create an account instantly and start sending payments. You can also contact us to design a custom package for your business.',
            but1: {
                text: 'Reconnect to QuickBooks',
                link: '/quickbooks',
            },
            but2: {
                Text: 'Contact Sales',
                link: '/en-ca/resource/contact-sales/',
            },
            col1Header: 'Always know what you pay',
            col1Text: 'Integrated per-transaction pricing with no hidden fees.',
            col1Btn: {
                text: 'Pricing details',
                link: '/en-ca/pricing/',
            },
            col2Header: 'Start your integration',
            col2Text: 'Get up and running with Checkbook in as little as 10 minutes.',
            col2Btn: {
                text: 'API reference',
                link: 'https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
            },
        },
    },
    frca_joinFooterItems: {
        root: {
            title: 'Prêt à commencer?',
            text:
                'Explorez Checkbook ou créez un compte instantanément et commencez à envoyer des paiements. Vous pouvez également nous contacter pour concevoir un service personnalisé pour votre entreprise. ',
            but1: {
                text: 'Créer un compte',
                link: 'https://app.checkbook.io/register',
            },
            but2: {
                text: 'Contacter l\'équipe commerciale',
                link: '/fr-ca/resource/contact-sales/',
            },
            col1Header: 'Sachez toujours ce que vous payez',
            col1Text: 'Tarification par transaction, sans frais cachés.',
            col1Btn: {
                text: "Détails des prix",
                link: '/fr-ca/pricing/',
            },
            col2Header: 'Démarrez votre intégration',
            col2Text: 'Soyez opérationnel avec Checkbook en aussi peu que 10 minutes.',
            col2Btn: {
                text: 'Référence API',
                link: 'https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
            },
        },
        compliance: {
            title: 'Prêt à commencer?',
            text:
                'Explorez Checkbook ou créez un compte instantanément et commencez à envoyer des paiements. Vous pouvez également nous contacter pour concevoir un service personnalisé pour votre entreprise. ',
            but1: {
                text: 'Créer un compte',
                link: 'https://app.checkbook.io/register',
            },
            but2: {
                text: 'Contacter l\'équipe commerciale',
                link: 'https://calendly.com/checkbook',
            },
            col1Header: 'Sachez toujours ce que vous payez',
            col1Text: 'Tarification par transaction, sans frais cachés.',
            col1Btn: {
                text: "Détails des prix",
                link: '/fr-ca/pricing/',
            },
            col2Header: 'Démarrez votre intégration',
            col2Text: 'Soyez opérationnel avec Checkbook en aussi peu que 10 minutes.',
            col2Btn: {
                text: 'Référence API',
                link: 'https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
            },
        },
        quickbooks_disconnect: {
            title: "Vous avez changé d'avis?",
            text:
                'Explorez Checkbook ou créez un compte instantanément et commencez à envoyer des paiements. Vous pouvez également nous contacter pour concevoir un service personnalisé pour votre entreprise. ',
            but1: {
                text: 'Se reconnecter à QuickBooks',
                link: '/quickbooks',
            },
            but2: {
                text: 'Contacter l\'équipe commerciale',
                link: '/fr-ca/resource/contact-sales/',
            },
            col1Header: 'Sachez toujours ce que vous payez',
            col1Text: 'Tarification par transaction, sans frais cachés.',
            col1Btn: {
                text: "Détails des prix",
                link: '/fr-ca/pricing/',
            },
            col2Header: 'Démarrez votre intégration',
            col2Text: 'Soyez opérationnel avec Checkbook en aussi peu que 10 minutes.',
            col2Btn: {
                text: 'Référence API',
                link: 'https://docs.checkbook.io/docs?auth_token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuYW1lIjoiQ2hlY2tib29rIERlbW8iLCJlbWFpbCI6ImRlbW9AY2hlY2tib29rLmlvIiwiZW52IjoiZGVtbyIsImFwaUtleSI6ImQ2YWEyNzAzNjU1ZjRiYTJhZjJhNTYyMDI5NjFjYTg2OmRYYkNnellCTWliajhad3VRTWQyTlhyNnJ0dmpaOCJ9.ucRb-jixtaVao7CVAWpH4LhiGZcytfQZfFTxOc1z7JQ',
            },
        },
    },
};
